import * as React from 'react';
import * as moment from 'moment';
import { CombinedProductionViewProps } from '../../components/list/production';
import { ListPerformancesBase } from '../../../add-ons/components/list/performances';

const ListProductionView = (props: CombinedProductionViewProps) => {
    const startDateMoment = moment(props.production.startDate);
    const endDateMoment = moment(props.production.endDate);
    return (
        <li className={"ace-event-card " + (props.showPerfsPanel ? 'ace-event-card-open' : '')}>
            <div className="ace-event">
                <div className="ace-event-half">
                    <div className="ace-event-date">
                        {
                            props.production.hideDate ?
                                null :
                                <>
                                    <p>
                                        <span className="ace-event-date-day">{startDateMoment.format("ddd")}</span>
                                        <span className="ace-event-date-number">{startDateMoment.format("MMM D")}</span>
                                        <span className="ace-event-date-time">{startDateMoment.format("h:mm A")}</span>
                                    </p>
                                    <div className="ace-event-date-decorator" role="presentation"></div>
                                    <p>
                                        <span className="ace-event-date-day">{endDateMoment.format("ddd")}</span>
                                        <span className="ace-event-date-number">{endDateMoment.format("MMM D")}</span>
                                        <span className="ace-event-date-time">{endDateMoment.format("h:mm A")}</span>
                                    </p>
                                </>
                        }
                    </div>
                    <div className="ace-event-image">
                        <div>
                            {
                                !!props.production.imageUrl &&
                                <img src={props.production.imageUrl} className="" alt="" />
                            }
                        </div>
                    </div>
                </div>
                <div className="ace-event-half ace-event-half-padded-right">
                    <div className="ace-event-content stack-lg">
                        <div className="ace-event-heading stack-sm">
                            <div className="flex-between">
                                {
                                    props.production.productionDetailPageUrl ?
                                        <>
                                            <h3 id={`Prod-Group-${props.production.title}`}><a href={props.production.productionDetailPageUrl} target="_blank">
                                                {props.production.title}</a></h3>
                                        </>
                                        :
                                        <h3 id={`Prod-Group-${props.production.title}`}>{props.production.title}</h3>
                                }

                                {
                                    props.addedToCart &&
                                    <svg className="svg-icon h3-style" focusable="false"><use xlinkHref="#icon-cart"></use></svg>
                                }
                            </div>

                            <div className={`rich-text`} dangerouslySetInnerHTML={{ __html: props.production.additionalInformation }}></div>
                        </div>
                        {
                            !!props.production.synopsis &&
                            <div className="stack">
                                <p>
                                    <button type="button" className={`btn-secondary dropdown-trigger ${props.showSynopsis ? 'dropdown-trigger-up' : 'dropdown-trigger-down'}`} onClick={props.toggleSynopsis}>{props.text.synopsisToggleButtonText}</button>
                                </p>
                                <div className={props.showSynopsis ? 'show' : 'hide'} dangerouslySetInnerHTML={{
                                    __html: props.production.synopsis
                                }}>
                                </div>
                            </div>
                        }
                        <div className="ace-event-ctas spaced-list">
                            <a className="btn" onClick={props.togglePerformancesPanel}>{props.showPerfsPanel ? props.text.performancesPanelClosedStateLabel : props.text.performancesPanelOpenStateLabel}</a>
                        </div>
                        <div className={props.showPerfsPanel ? 'show' : 'hide'}>
                            <ul className="stack">
                                {
                                    props.performanceAvailable ?
                                        props.production.performances.map(perf => <ListPerformancesBase key={`${perf.id}`}
                                            performanceInfo={perf} productionId={parseInt(props.production.id)} performancesCount={props.performancesCount} hideDate={props.production.hideDate} panelOpen={props.showPerfsPanel} />)
                                        : <div className="error-message">{props.text.productionUnavailableMessage}</div>
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    );
}

export default ListProductionView;